module.exports = __webpack_public_path__ + "img/download.67c71770.svg";